import { getEnv } from '@/utils/texts';

const BASE_URL = getEnv('VITE_BASE_URL');
const COGNITO_PROJECT_REGION = getEnv('VITE_COGNITO_PROJECT_REGION');
const COGNITO_REGION = getEnv('VITE_COGNITO_REGION');
const COGNITO_POOL_ID = getEnv('VITE_COGNITO_POOL_ID');
const COGNITO_CLIENT_ID = getEnv('VITE_COGNITO_CLIENT_ID');
const COGNITO_DOMAIN = getEnv('VITE_COGNITO_DOMAIN');
const COGNITO_IDENTITY_POOL_ID = getEnv('VITE_COGNITO_IDENTITY_POOL_ID');
const ONLINE_TEST_URL = getEnv('VITE_ONLINE_TEST_URL');
const ONLINE_TEST_VERSION = getEnv('VITE_ONLINE_TEST_VERSION');
const FIREBASE_API_KEY = getEnv('VITE_FIREBASE_API_KEY');
const FIREBASE_PROJECT_ID = getEnv('VITE_FIREBASE_PROJECT_ID');
const FIREBASE_MESSAGING_SENDER_ID = getEnv('VITE_FIREBASE_MESSAGING_SENDER_ID');
const FIREBASE_APP_ID = getEnv('VITE_FIREBASE_APP_ID');
const FIREBASE_AUTH_DOMAIN = getEnv('VITE_FIREBASE_AUTH_DOMAIN');
const VAPID_KEY = getEnv('VITE_VAPID_KEY');
const ZENDESK_KEY = getEnv('VITE_ZENDESK_KEY');
const INTERVIEW_AGENT_BASE_URL = getEnv('VITE_INTERVIEW_AGENT_BASE_URL');
const LIVE_INTERVIEW_BASE_URL = getEnv('VITE_LIVE_INTERVIEW_BASE_URL');
const AUTH_BASE_URL = getEnv('VITE_AUTH_BASE_URL');
const JWT_SECRET_KEY = getEnv('VITE_JWT_SECRET_KEY');
const LOCAL_BASE_URL = getEnv('VITE_LOCAL_BASE_URL');
const VITE_RESUME_PARSER_BASE_URL = getEnv('VITE_RESUME_PARSER_BASE_URL');
const VITE_JOB_CAMPAIGN_BASE_URL = getEnv('VITE_JOB_CAMPAIGN_BASE_URL');
const VITE_CUSTOM_SCORE_BASE_URL = getEnv('VITE_CUSTOM_SCORE_BASE_URL');
const VITE_SENTRY_DSN = getEnv('VITE_SENTRY_DSN');
const VITE_APP_ENV = getEnv('VITE_APP_ENV') || 'development';

const config = {
  baseUrl: BASE_URL,
  cognitoProjectRegion: COGNITO_PROJECT_REGION,
  cognitoRegion: COGNITO_REGION,
  cognitoPoolId: COGNITO_POOL_ID,
  cognitoClientId: COGNITO_CLIENT_ID,
  cognitoDomain: COGNITO_DOMAIN,
  cognitoIdentityPoolId: COGNITO_IDENTITY_POOL_ID,
  onlineTestUrl: `${ONLINE_TEST_URL}/api/${ONLINE_TEST_VERSION}`,
  firebase: {
    apiKey: FIREBASE_API_KEY,
    authDomain: FIREBASE_AUTH_DOMAIN,
    projectId: FIREBASE_PROJECT_ID,
    messagingSenderId: FIREBASE_MESSAGING_SENDER_ID,
    appId: FIREBASE_APP_ID,
  },
  firebaseVapidKey: VAPID_KEY,
  zendeskKey: ZENDESK_KEY,
  interviewAgentBaseUrl: INTERVIEW_AGENT_BASE_URL,
  liveInterviewBaseUrl: LIVE_INTERVIEW_BASE_URL,
  authBaseUrl: AUTH_BASE_URL,
  localBaseUrl: LOCAL_BASE_URL,
  resumeParserBaseUrl: VITE_RESUME_PARSER_BASE_URL,
  jobCampaignBaseUrl: VITE_JOB_CAMPAIGN_BASE_URL,
  customScoreBaseUrl: VITE_CUSTOM_SCORE_BASE_URL,
  secretKey: JWT_SECRET_KEY,
  sentryDsn: VITE_SENTRY_DSN,
  appEnv: VITE_APP_ENV,
};

export default config;
